<template>
    <div class="invisible2" :class="{ 'show': !showmodal, 'showdarkoverlay': props.showdarkoverlay }">
        <div id="common_dialog_error2"
            :class="[{ 'modal2': !props.showdarkoverlay }, { 'fullWidth': props.isfullwidth }, 'modal']">
            <div :class="['contentImage', { 'contentImage2': !props.alerttype }]">
                <img v-if="props.alerttype" height="80px" width="80px"
                    v-bind:style="{ backgroundColor: getColor(props.alerttype), borderRadius: '60px' }"
                    :src="getImageSrc(props.alerttype)" id="alertImage" :alt="getAltText(props.alerttype)"
                    :aria-label="getAriaLabel(props.alerttype)" />
            </div>
            <div style="text-align: right; background: red; width: 94%;">
                <button v-if="props.showbtnclose" @click="closeButton" id="closeBtnModal"
                    :class="[{ 'closeBtnModal': !props.alerttype }]" alt="Botón de cerrar"
                    aria-label="Cerrar modal">×</button>
            </div>
            <header class="headerModal">
                <p v-if="props.title" class="titleHeader" role="header">{{ props.title }}</p>
            </header>
            <div class="contentModal">
                <p>{{ props.message }}</p>
                <div v-if="resumenval" class="resumenval" v-html='resumenval'></div>
            </div>
            <div id="dynamicContent" class="center-dynamicContent">
                <PandoraButton v-if="textbuttona" :aria-label="textbuttona" @click="actionBtn1" role="button"
                    variant="primary" :label="textbuttona" size="s" />
                <PandoraButton v-if="textbuttonb" :aria-label="textbuttonb" @click="actionBtn2" role="button"
                    variant="dark" :label="textbuttonb" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, watch } from 'vue';
import PandoraButton from '../button/PandoraButton.vue';

import infoImg from '../../assets/ImgModal/info.png';
import okImg from '../../assets/ImgModal/ok.png';
import warningImg from '../../assets/ImgModal/warning.png';
import errorImg from '../../assets/ImgModal/error.png';

const props = defineProps({
    isfullwidth: {
        default: false
    },
    message: {
        type: String,
        default: ''
    },
    showmodal: {
        default: false
    },
    showbtnclose: {
        default: true
    },
    showdarkoverlay: {
        default: false
    },
    resumenval: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    alerttype: {
        type: String,
        default: ''
    },
    textbuttona: {
        type: String,
        default: ''
    },
    textbuttonb: {
        type: String,
        default: ''
    },
    actionbtn1func: Function,
    actionbtn2func: Function,
    closebuttonfunc: Function
})

const getImageSrc = (alerttype) => {
    const imageMap = {
        error: errorImg,
        info: infoImg,
        warning: warningImg,
        ok: okImg
    };
    if (alerttype) return imageMap[alerttype];
    else return errorImg
}

const getAltText = (alerttype) => {
    const altTextMap = {
        error: "Error",
        info: "Información",
        warning: "Advertencia",
        ok: "Ok"
    };
    return altTextMap[alerttype];
}

const getColor = (alerttype) => {
    const colorMap = {
        error: "#B50303",
        info: "#2196F3",
        warning: "#E7A304",
        ok: "#2E7300"
    };
    return colorMap[alerttype];
}

const getAriaLabel = (alerttype) => {
    const ariaLabelMap = {
        error: "Alerta de error",
        info: "Alerta de información",
        warning: "Alerta de advertencia",
        ok: "Alerta de exitoso"
    };
    return ariaLabelMap[alerttype];
}


const closeModal = () => {
    showmodal.value = '';
}

const actionBtn1 = () => {
    if (props.actionbtn1func) {
        props.actionbtn1func()
    }
    showmodal.value = false;
}

const actionBtn2 = () => {
    if (props.actionbtn2func) {
        props.actionbtn2func();
    }
    showmodal.value = false;
}

const closeButton = () => {
    if (props.closebuttonfunc) {
        props.closebuttonfunc(this);
    }
    closeModal();
}
const showmodal = ref(props.showmodal);

watch(() => props.showmodal, (newVal) => {
    showmodal.value = newVal;
});

</script>

<style>
#closeBtnModal {
    padding: 0;
    margin-top: -49px;
    border: none;
    height: 20px;
    width: 20px;
    cursor: pointer;
    position: absolute;
    box-shadow: 0px 0px 3px 0px rgba(173, 173, 173, 0.75);
    -webkit-box-shadow: 0px 0px 3px 0px rgba(173, 173, 173, 0.75);
    -moz-box-shadow: 0px 0px 3px 0px rgba(173, 173, 173, 0.75);
    border-top-right-radius: 5px;
    border-bottom-left-radius: 5px;
    font-size: 20px;
}

#closeBtnModal:hover {
    background: rgb(226, 226, 226);
}

.closeBtnModal {
    margin-top: -21px !important;
}

.headerModal button {
    position: relative !important;
    right: 0 !important;
    top: 5px !important;
}

#dynamicContent {
    text-align: right;
    display: ruby-text;
    padding-inline: 10px;
    padding-bottom: 15px;
    button {
        margin-inline: 10px
    }
}

.center-dynamicContent {
    text-align: center !important;
}

.contentModal .resumenVal,
.contentModal .resumenval {
    color: #4f4f4f;
}

.dynamicButton {
    margin-block: 13px;
    margin-inline: 10px;
    padding-inline: 10px;
    padding-block: 5px;
    font-size: 13px;
    border-radius: 3px;
    border: 1px solid #c5c5c5;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #ededed), color-stop(100%, #c4c4c4));
    color: #4F4F4F;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.6);
    font-weight: 600;
    height: 27px;
    cursor: pointer;
    display: inline-block;
}


.contentImage {
    width: 100%;
    text-align: center;
    margin-top: -35px
}

.contentImage2 {
    margin-top: -59px !important;
    height: 80px !important;
}



.show {
    display: none !important;
}

.dynamicButton:hover {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
}

.dynamicButton:active {
    color: #1c5742;
    border-color: #70ab96;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #b9f5e0), color-stop(100%, #92d6bd));
}

.contentModal {
    padding-inline: 20px;
    margin: 10px 0 2em 0;
    text-align: center;
}

.contentModal p {
    font-family: Arial, sans-serif;
    color: #4F4F4F;
    font-size: 14px;
    margin: 0;
}

.classHeader {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    align-items: center;
}

.showdarkoverlay {
    background: rgba(0, 0, 0, 0.2);
}

.invisible2 {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
}

.headerModal {
    width: auto;
    font-family: Arial, sans-serif;
    color: #333;
    padding: 1em 1em 0 1em;
}

.modal {
    border-radius: 7px;
    border: 0.5px solid #c5c5c5;
    background: #FFF;
    min-width: 330px;
    height: auto;
    align-items: center;
    justify-content: center;
    position: relative !important;
    inline-size: auto;
    max-width: 430px;
}

.modal2 {
    box-shadow: 0 0px 80px rgba(0, 0, 0, 0.2);
}

.fullWidth {
    max-width: 90% !important;
    width: 90% !important;
}

.titleHeader {
    font-size: 18px;
    text-align: center;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
    color: #4F4F4F;
    font-weight: bold;
    margin: 0;
    padding-bottom: 0.5em;
}
</style>